// extracted by mini-css-extract-plugin
module.exports = {"quantity":"styles_quantity__1MD6V"};